<template>
  <div class="c-band-size-selector l-flex">
    <div class="c-band-size-selector__container l-flex l-flex--column">
      <h1
        ref="headingToFocus"
        class="c-band-size-selector__title t-heading-5 u-margin-bottom-small"
        tabindex="0"
      >
        {{ step.personalizationTitle }}
      </h1>
      <wysiwyg
        class="c-band-size-selector__description t-paragraph-large u-margin-bottom-small u-text-align-center"
        :html="step.personalizationDescription"
      />
      <p
        v-if="stepHelpText"
        id="aria-size-text"
        class="c-band-size-selector__help-text t-paragraph-small u-margin-bottom-small"
      >
        {{ stepHelpText }}
      </p>
      <div class="l-flex">
        <size-picker
          :options="sizeOptions"
          :active-option="bandSize"
          :size-help-text="mapHelpText"
          class="u-margin-bottom-medium"
          :max-columns="4"
          @select="updateSize"
        />
      </div>
      <btn
        :class-modifiers="step.button.fields.type"
        :disabled="!selections.size"
        class="c-band-color-selector__next-btn u-margin-bottom-x-small"
        @click="incrementStep"
      >
        {{ step.button.fields.text }} {{ nextStep ? nextStep.shortTitle : "" }}
      </btn>
      <btn
        type="link"
        url="#"
        @click="decrementStep"
      >
        BACK
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/button/Btn";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import SizePicker from '../sizePicker/SizePicker'
import Wysiwyg from "@/components/wysiwyg/Wysiwyg";

export default {
  name: "BandSizeSelector",
  components: {
    Wysiwyg,
    Btn,
    SizePicker
  },
  props: {
    step: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      sizeOptions: ['S', 'M', 'L', 'XL']
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'bracelets',
      'selections',
      'currentStep'
    ]),
    ...mapGetters('braceletBuilder',[
      'loading',
      'nextStep',
      'bandColor'
    ]),
    stepHelpText() {
      const bandSize = this.bandSize
      let result = null
      switch (bandSize) {
      case 'S':
        result = this.SizeHelpTextGetter('S')
        break
      case 'M':
        result = this.SizeHelpTextGetter('M')
        break
      case 'L':
        result = this.SizeHelpTextGetter('L')
        break
      case 'XL':
        result = this.SizeHelpTextGetter('XL')
        break
      }
      return result
    },
    mapHelpText() {
      let result = {}
      result['S'] = this.SizeHelpTextGetter('S')
      result['M'] = this.SizeHelpTextGetter('M')
      result['L'] = this.SizeHelpTextGetter('L')
      result['XL'] = this.SizeHelpTextGetter('XL')
      return result
    },
    bandParentProduct() {
      const { bracelet } = this.selections
      let result = null
      for (let band of this.bracelets) {
        if (band.handle === bracelet.handle) {
          result = band
          break
        }
      }
      return result
    },
    bandSize() {
      const selections = this.selections
      let result = null
      if (selections && selections.bracelet && selections.size) {
        const bracelet = selections.bracelet
        const { selectedOptions } = bracelet || {}
        for (let option of (selectedOptions || [])) {
          if (option && (option.name === 'Size')) {
            result = option.value
            break
          }
        }
      }
      return result
    }
  },
  mounted() {
    const headingToFocus = this.$refs.headingToFocus;
    if (headingToFocus) {
      this.$refs.headingToFocus.focus();
    }
  },
  methods: {
    ...mapMutations('braceletBuilder', [
      'update'
    ]),
    ...mapActions('braceletBuilder', [
      'incrementStep',
      'decrementStep',
    ]),
    getVariantFromSize(size) {
      const bracelet = this.bandParentProduct
      let result = null
      if (bracelet && bracelet.variants) {
        for (let variant of bracelet.variants) {
          const { selectedOptions } = variant || {}
          for (let option of (selectedOptions || [])) {
            if (
              option &&
              (option.name === 'Size') &&
              (option.value === size)
            ) {
              result = variant
            }
          }
          if (result) {
            break
          }
        }
      }
      return result
    },
    updateSize(size) {
      const variant = this.getVariantFromSize(size)
      this.update({
        'bracelet': variant,
        'size': variant.title
      })
    },
    SizeHelpTextGetter(bandSize) {
      let result = null
      switch (bandSize) {
      case 'S':
        result = `
          Fit for kids and women with small wrists: 6.0" circumference (15.2cm)
        `
        break
      case 'M':
        result = `
          Fit for teens and most women: 6.5" circumference (16.5cm)
        `
        break
      case 'L':
        result = `
          Fit for most men: 7.0" circumference (17.7 cm)
        `
        break
      case 'XL':
        result = `
          Fit for larger wrists: 7.5" circumference (19cm)
        `
        break
      }
      return result
    }
  },
}
</script>

<style lang="scss" scoped>
  .c-band-size-selector {
    &__description p a {
      @include themify($themes) {
        color: themed('foreground', 'light-text');
      }
    }
    &__help-text {
      @include themify($themes) {
        color: themed('foreground', 'light');
      }
    }
  }
</style>
